<template>
  <div>
    <div :class="[$style['header-wrapper'], showToggleRequest ? $style['header-wrapper--z-index'] : []]">
      <top-header />
    </div>
    <div :class="[$style['inner']].concat(isMobileMenuOpen
        ? [$style['inner--mobile-menu-active']]
        : [])
      ">
      <div
        :class="$style['side-menu-wrapper']"
        class="side-menu-wrapper"
      >
        <ds-collapse-menu
          :side-arrow-on-active="true"
          :items="sideMenuItems"
        />
      </div>
      <div
        :class="$style['content-wrapper']"
        @click="closeMobileMenu"
      >
        <transition
          name="route-fade"
          mode="out-in"
        >
          <router-view />
        </transition>
      </div>
    </div>
    <!-- <feature-request
      :open="showToggleRequest"
      @open="toggleFeatureRequest"
    />
    <div
      :class="[$style['background-layer'], showToggleRequest ? $style['background-layer--active'] : []]"
      @click="toggleFeatureRequest"
    /> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import TopHeader from "../components/top-header";
import Icons from "ds-theme/src/js/icons";
import { closeMobileMenu } from "@/app/ui/store/mutations";
import FeatureRequest from "../components/feature-request";

export default {
  components: {
    TopHeader,
    FeatureRequest
  },
  data() {
    return {
      showToggleRequest: false
    };
  },
  computed: {
    ...mapState({
      isMobileMenuOpen: state => state.ui.isMobileMenuOpen
    }),
    sideMenuItems: () => {
      return [
        {
          name: "BGP route",
          displayName: "BGP route",
          image: Icons.DsCubeIcon,
          url: { name: "bgp" }
        },
        {
          name: "PING",
          displayName: "PING",
          image: Icons.DsCubeIcon,
          url: { name: "PING" }
        },
        {
          name: "Generator haseł",
          displayName: "Generator haseł",
          image: Icons.DsCubeIcon,
          url: { name: "password-generator" }
        },
        {
          name: "Generator haseł htpasswd",
          displayName: "Generator haseł htpasswd",
          image: Icons.DsCubeIcon,
          url: { name: "htpasswd-password-generator" }
        },
        {
          name: "SPF check",
          displayName: "SPF check",
          image: Icons.DsCubeIcon,
          url: { name: "spf-check" }
        },
        {
          name: "HTTP headers",
          displayName: "HTTP headers",
          image: Icons.DsCubeIcon,
          url: { name: "http-headers" }
        },
        {
          name: "DNS tool",
          displayName: "DNS tool",
          image: Icons.DsCubeIcon,
          url: { name: "dns-tool" }
        }
      ];
    }
  },
  watch: {
    isMobileMenuOpen: function(value) {
      document.body.className = value ? "mobile-open" : "";
    }
  },
  methods: {
    closeMobileMenu: function() {
      if (this.isMobileMenuOpen) {
        this.$store.commit(closeMobileMenu());
      }
    },
    toggleFeatureRequest: function() {
      this.showToggleRequest = !this.showToggleRequest;
    }
  }
};
</script>

<style lang="scss">
.side-menu-wrapper {
  .side-menu__link {
    align-items: flex-start !important;
  }
  .side-menu__item-name {
    color: #fff !important;
  }
}
</style>


<style lang="scss" module>
@import "~@app/scss/_variables.scss";
@import "~@theme/scss/_mixins.scss";
@import "~@theme/scss/_variables.scss";

.header-wrapper {
  position: fixed;
  top: 0;
  display: flex;
  height: $top-height;
  width: 100%;
  background-color: #fff;
  z-index: 2;
  box-shadow: 0px 11px 10px -10px rgba(12, 0, 51, 0.1);
  @include mobile() {
    left: 0px;
  }
  &--z-index {
    z-index: -1;
  }
}
.content-wrapper {
  margin-top: $top-height;
  margin-left: $side-menu-width;
  min-height: calc(100vh - #{$top-height});
  background-color: $light-blue-silver-color;
  padding: 16px 32px 16px 40px;
  overflow: hidden;
  @include mobile() {
    padding: 10px 20px;
    margin-left: 0px;
  }
  transition: transform $transition-duration;
}
.side-menu-wrapper {
  position: fixed;
  top: $top-height;
  width: $side-menu-width;
  min-height: calc(100vh - #{$top-height});
  height: calc(100vh - #{$top-height});
  color: #fff;
  background-color: $navy-blue-color;
  overflow-y: auto;
  @include mobile() {
    left: -$side-menu-width;
    top: 0px;
    height: calc(100vh - #{$top-height}) !important;
  }
}
.inner {
  height: 100%;
  @include mobile() {
    transition: transform $transition-duration;
    transform: translate(0px, 0px);
    &--mobile-menu-active {
      transition: transform $transition-duration;
      transform: translate3d($side-menu-width, 0px, 0px);
    }
  }
}
.background-layer {
  position: fixed;
  transition: 0.3s;
  &--active {
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(70, 101, 117, 0.2);
  }
}
</style>



// WEBPACK FOOTER //
// src/app/dashboard/views/dashboard.vue